/**
 * Created by jonas on 2022-10-27.
 */
import {Outsourced} from "../Outsourced";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {OutsourcedXWaysSymbol} from "../reels/symbols/XWaysSymbol";
import {OutsourcedSymbol} from "../reels/symbols/OutsourcedSymbol";
import {OutsourcedReelView} from "../reels/OutsourcedReelView";
import {OutsourcedSymbolFactory} from "../reels/symbols/SymbolFactory";
import {OutsourcedGameAssets} from "../OutsourcedGameAssets";
import {OutsourcedModel} from "../server/OutsourcedModel";
import {XNudgeSymbol} from "../reels/symbols/XNudgeSymbol";

export class RestoreUtils {

    public static isActionSpins = false;

    constructor() {
    }

    public static startupGame() {
        if (Outsourced.model.isRestore){
            RestoreUtils.restore();
        } else {
            RestoreUtils.normalStartUp();
        }
    }

    public static normalStartUp() {
        const reelData = Outsourced.model.initData.reels;
        const reels = Outsourced.reelView.reelModels;
        for (let reel = 0; reel < 4; reel++) {
            for (let row = 0; row < 4; row++) {
                const symbol = Outsourced.symbolFactory.createSymbol({symbolName: reelData[reel][row],
                                                                          reelID: reel,
                                                                          reelPosition: 0})
                reels[reel * 4 + row].insertSymbols([symbol]);
            }
        }
        Outsourced.reelView.extractSymbols();
        Outsourced.reelView.updateWays(Outsourced.model.postXwaysWays());
        // make sure potential xways symbols show up correctly
        for (let reel = 0; reel < 4; reel++) {
            for (let row = 0; row < 4; row++) {
                if (Outsourced.model.actualSymbolSizes[reel][row] > 1) {
                    const xWaysTarget = reelData[reel][row];
                    const ways = Outsourced.model.actualSymbolSizes[reel][row];
                    const symbol = Outsourced.symbolFactory.createSymbol({symbolName: "XW",
                                                                              reelID: reel,
                                                                              reelPosition: 0});
                    (<OutsourcedXWaysSymbol>symbol).restore(xWaysTarget, ways);
                    Outsourced.reelView.setSymbolAt(reel, row, symbol);
                }
            }
        }
    }

    public static restoreXWays() {
        const reelData = Outsourced.model.data.reels;
        const xWaysSymbol = Outsourced.model.data.xWaysSymbol;
        const ways = Outsourced.model.actualSymbolSizes;
        for (let reel = 0; reel < 4; reel++) {
            for (let row = 0; row < 4; row++) {
                if (reelData[reel][row] == "XW")
                    (<OutsourcedXWaysSymbol>Outsourced.reelView.getSymbolAt(reel, row)).restore(xWaysSymbol, ways[reel][row]);
            }
        }
    }

    public static restoreXNudge() {
        Outsourced.reelView.getAllSymbols().filter((sym) => sym.symbolName == "XN").forEach((sym) => {
            const reelIndex = sym.reelID;
            const rowIndex = Outsourced.model.data.reels[reelIndex].findIndex((sym) => sym == "XN");
            const rowOrder = rowIndex == 0
                             ? [1, 2, 3]
                             : rowIndex == 1
                             ? [0, 2, 3]
                             : rowIndex == 2
                             ? [1, 3, 0]
                             : [2, 1, 0];

            (<XNudgeSymbol>sym).expand(rowIndex).progress(1);
            for (let i = 0; i < 3; i++) {
                const newSymbol = <XNudgeSymbol>Outsourced.symbolFactory.createSymbol({
                    symbolName: "XN",
                    reelID: reelIndex,
                    reelPosition: 0
                });
                newSymbol.hideMultiplier();
                Outsourced.reelView.setSymbolAt(reelIndex, rowOrder[i], newSymbol);
            }
        })

    }

    public static restore() {
        const model = Outsourced.model;
        const reelData = model.initData.reels;
        const reels = Outsourced.reelView.reelModels;
        for (let reel = 0; reel < 4; reel++) {
            for (let row = 0; row < 4; row++) {
                const symbol = Outsourced.symbolFactory.createSymbol({symbolName: reelData[reel][row],
                                                                          reelID: reel,
                                                                          reelPosition: 0})
                reels[reel * 4 + row].insertSymbols([symbol]);
                if (model.initData.winningSymbols.length > 0 && model.initData.winningSymbols[reel][row] == 1)
                    Outsourced.reelView.setMultiplierTo(model.data.splitSizes[reel][row] + 1, reel, row);
                else
                    Outsourced.reelView.setMultiplierTo(model.data.splitSizes[reel][row], reel, row);
            }
        }
        Outsourced.reelView.extractSymbols();
        Outsourced.reelView.updateWays(Outsourced.model.postXwaysWays());
        RestoreUtils.restoreXWays();
        RestoreUtils.restoreXNudge();
        if (Outsourced.model.isFreespins() && Outsourced.model.data.nextMode != "UPGRADE_BET" && Outsourced.model.data.upgradeBetCount < 1) {
            if (Outsourced.model.data.scatterCount == 4)
                Outsourced.backgroundElements.setToSuperFreespins()
            else
                Outsourced.backgroundElements.setToFreespins()
            Outsourced.reelView.setToFreespins();
        }

        Outsourced.keypadPlugin.setWin(Outsourced.model.data.accumulatedRoundWin,
                                       Outsourced.model.data.mode != GameMode.NORMAL,
                                       Outsourced.isWinBelowStake());
    }

    public static restorePlayBonusInGame() {
        RestoreUtils.isActionSpins = true;

        const model = Outsourced.model;
        const reelData = model.data.reels;
        const reels = Outsourced.reelView.reelModels;

        Outsourced.reelView.insertSymbols();
        for (let reel = 0; reel < 4; reel++) {
            for (let row = 0; row < 4; row++) {
                const symbol = Outsourced.symbolFactory.createSymbol({symbolName: reelData[reel][row],
                    reelID: reel,
                    reelPosition: 0})
                reels[reel * 4 + row].extractSymbols();
                reels[reel * 4 + row].insertSymbols([symbol]);
                if (model.data.winningSymbols.length > 0 && model.data.winningSymbols[reel][row] == 1)
                    Outsourced.reelView.setMultiplierTo(model.data.splitSizes[reel][row] + 1, reel, row);
                else
                    Outsourced.reelView.setMultiplierTo(model.data.splitSizes[reel][row], reel, row);
            }
        }

        Outsourced.reelView.extractSymbols();
        Outsourced.reelView.updateWays(Outsourced.model.postXwaysWays());
        RestoreUtils.restoreXWays();
        RestoreUtils.restoreXNudge();

        Outsourced.keypadPlugin.setWin(Outsourced.model.data.accumulatedRoundWin,
            Outsourced.model.data.mode != GameMode.NORMAL,
            Outsourced.isWinBelowStake());
    }
}